import { ChartingItemType } from '@caresend/types';
import '@caresend/utils';
import 'vue';
import 'dayjs';
import '@sentry/vue';
import '@fortawesome/fontawesome-svg-core';
import '@fortawesome/sharp-regular-svg-icons';
import 'buefy';

const getChartingResultInputs = (chartingItems) => {
    if (!chartingItems)
        return null;
    let results = [];
    chartingItems.forEach((item) => {
        if (item.type === ChartingItemType.RESULTS) {
            results.push(item);
        }
        if (item.type === ChartingItemType.GROUP) {
            const childResults = getChartingResultInputs(item.children);
            if (childResults)
                results = results.concat(childResults);
        }
    });
    return results;
};

export { getChartingResultInputs };
